export const CHANNEL_SIMPLE_ACCESS_TYPES = Object.freeze({
  DISABLED: "disabled",
  PUBLIC: "public",
  IP_RANGE: "ip_range",
});
